/** Trade categories with slugs for the browse UI and signup forms. */
export const TRADE_CATEGORIES = [
  { name: "Plumber", slug: "plumber" },
  { name: "Electrician", slug: "electrician" },
  { name: "Builder", slug: "builder" },
  { name: "Carpenter", slug: "carpenter" },
  { name: "Roofer", slug: "roofer" },
  { name: "Painter & Decorator", slug: "painter-decorator" },
  { name: "Plasterer", slug: "plasterer" },
  { name: "Tiler", slug: "tiler" },
  { name: "Locksmith", slug: "locksmith" },
  { name: "Landscaper", slug: "landscaper" },
  { name: "Gardener", slug: "gardener" },
  { name: "Handyman", slug: "handyman" },
  { name: "Kitchen Fitter", slug: "kitchen-fitter" },
  { name: "Bathroom Fitter", slug: "bathroom-fitter" },
  { name: "Gas Engineer", slug: "gas-engineer" },
  { name: "Heating Engineer", slug: "heating-engineer" },
  { name: "Window Fitter", slug: "window-fitter" },
  { name: "Driveway Specialist", slug: "driveway-specialist" },
  { name: "Fencing Specialist", slug: "fencing-specialist" },
  { name: "Flooring Specialist", slug: "flooring-specialist" },
  { name: "Pest Control", slug: "pest-control" },
  { name: "Cleaner", slug: "cleaner" },
  { name: "Removals", slug: "removals" },
  { name: "Architect", slug: "architect" },
  { name: "Surveyor", slug: "surveyor" },
  // New categories
  { name: "Bricklayer", slug: "bricklayer" },
  { name: "Groundworker", slug: "groundworker" },
  { name: "Scaffolder", slug: "scaffolder" },
  { name: "Rendering Specialist", slug: "rendering-specialist" },
  { name: "Chimney Sweep", slug: "chimney-sweep" },
  { name: "Drainage Specialist", slug: "drainage-specialist" },
  { name: "Alarm & Security Installer", slug: "alarm-security-installer" },
  { name: "Aerial & Satellite Installer", slug: "aerial-satellite-installer" },
  { name: "Appliance Repair", slug: "appliance-repair" },
  { name: "EV Charger Installer", slug: "ev-charger-installer" },
  { name: "Solar Panel Installer", slug: "solar-panel-installer" },
  { name: "Heat Pump Installer", slug: "heat-pump-installer" },
  { name: "Garage Door Specialist", slug: "garage-door-specialist" },
  { name: "Loft Conversion Specialist", slug: "loft-conversion-specialist" },
  { name: "Damp Proofing Specialist", slug: "damp-proofing-specialist" },
  { name: "Insulation Specialist", slug: "insulation-specialist" },
  { name: "Tree Surgeon", slug: "tree-surgeon" },
  { name: "Paving Specialist", slug: "paving-specialist" },
  { name: "Skip Hire", slug: "skip-hire" },
  { name: "Conservatory Specialist", slug: "conservatory-specialist" },
] as const;

export type TradeSlug = (typeof TRADE_CATEGORIES)[number]["slug"];

export function getTradeName(slug: string): string {
  const match = TRADE_CATEGORIES.find((t) => t.slug === slug);
  if (match) return match.name;
  // Fallback for unknown/legacy slugs: render a readable title rather than a raw
  // slug (e.g. "gas-engineer" -> "Gas Engineer").
  if (!slug) return "Tradesperson";
  return slug
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
